import { Reveal } from "./Reveal";

export const ClosingCTA = () => (
  <section
    data-testid="closing-cta-section"
    className="grain relative overflow-hidden border-t border-leaf/10 bg-evergreen text-white"
  >
    <div
      className="absolute -bottom-40 left-1/2 h-[380px] w-[680px] -translate-x-1/2 rounded-full bg-growth/20 blur-3xl"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-[760px] px-4 py-24 text-center sm:px-6 lg:py-28">
      <Reveal>
        <p className="font-display text-xs font-semibold uppercase tracking-[0.22em] text-leaf sm:text-sm">
          What's next
        </p>
        <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight sm:text-5xl">
          Build something worth using.
        </h2>
        <p className="mx-auto mt-6 max-w-[560px] font-body text-lg leading-relaxed text-sage">
          CoachER is only the beginning. Follow what we're building or get in touch.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="https://trycoacher.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="closing-explore-coacher-btn"
            className="rounded-xl bg-growth px-7 py-3.5 font-display text-base font-semibold text-white transition-colors duration-200 hover:bg-white hover:text-evergreen"
          >
            Explore CoachER
          </a>
          <a
            href="mailto:support@buildmakewin.com"
            data-testid="closing-contact-btn"
            className="rounded-xl border border-cream/40 px-7 py-3.5 font-display text-base font-semibold text-cream transition-colors duration-200 hover:bg-cream hover:text-evergreen"
          >
            Contact us
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
